module.exports = __webpack_public_path__ + "img/p1-m.17e00f99.jpg";